import { render, staticRenderFns } from "./Componente.vue?vue&type=template&id=09bcd766"
import script from "./Componente.vue?vue&type=script&lang=js"
export * from "./Componente.vue?vue&type=script&lang=js"
import style0 from "./Componente.vue?vue&type=style&index=0&id=09bcd766&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports